import React from "react";
import HighChartVariablePie from "../../shared/highchart/variable-pie/HighChartVariablePie";
import StudentPerformanceChartState, { StudentPerformanceChartProps } from "./StudentPerformanceChart.models";
import './StudentPerformanceChart.scss';
import DatePickerPeriod from "../../shared/date-picker/period/DatePickerPeriod";
import { PeriodDateJson } from "../../../models/dtos/chart/PeriodDateJson";
import StudentService from "../../../services/student/StudentService";
import NotFoundDataInDate from "../../shared/not-found-data-in-date/NotFoundDataInDate";

export default class StudentPerformanceChart extends React.PureComponent<StudentPerformanceChartProps, StudentPerformanceChartState> {
    studentService: StudentService;
    constructor(props: any) {
        super(props);
        this.studentService = new StudentService();
        this.state = {
            datas: []
        };
    }

    componentDidMount() {
    }

    selectPeridDate = (periodDate: PeriodDateJson) => {
        let self = this;
        //#TODO changing to persian date

        if (periodDate !== undefined && periodDate !== null)
            self.getData(periodDate);
    }

    getData(periodDate: PeriodDateJson) {
        let self = this;
        self.clear();

        self.studentService.studyTime({
            fromDate: periodDate.persianCreationFrom,
            toDate: periodDate.persianCreationTo
        }).then(function (response) {
            self.setState({ datas: response });
        });
    }

    clear() {
        let self = this;
        self.setState({ datas: [] });
    }

    render(): React.ReactNode {

        let datas = this.state.datas;
        let content;
        if (datas.length > 0) {
            content = (<HighChartVariablePie Datas={datas} />);
        } else {
            content = (<NotFoundDataInDate />);
        }

        return (<>
            <div className="mr-lg-5" style={{ marginBottom: "12px" }}>
                <DatePickerPeriod afterSelect={this.selectPeridDate} color="#b9b9b9" />
            </div>

            {content}
        </>)
    }
}


